<template>
  <curation-component/>
</template>

<script>
import CurationComponent from '@/spa/components/board/curation/BoardCuration';

export default {
  name: 'CurationPage',
  components: {
    CurationComponent,
  },
};
</script>



// WEBPACK FOOTER //
// src/spa/pages/contents/CurationPage.vue